import { Navigate, useSearchParams } from 'react-router-dom';

import { readOrderUrlState, stepUrl, type OrderStepId } from './steps';

export interface RetiredStepProps {
  /** The step that answers for the one that no longer exists. */
  to: OrderStepId;
}

/**
 * A checkout step that has been removed, answered with its replacement.
 *
 * `/order/upload`, `/review` and `/options` walked a single file through the
 * flow one screen at a time, and `/order/address` asked a question Details
 * now asks. They were live URLs: a customer has them in their history, a
 * half-finished order may be sitting in a tab, and a 404 is a worse answer
 * than the screen that replaced them.
 *
 * `replace`, so the dead URL does not sit in history waiting for the back
 * button to find it, and `stepUrl`, so the quote id rides along — somebody
 * bounced from `/order/address?q=…` lands on Details with their order
 * intact rather than back at the beginning.
 */
export function RetiredStep({ to }: RetiredStepProps) {
  const [searchParams] = useSearchParams();
  return <Navigate to={stepUrl(to, readOrderUrlState(searchParams))} replace />;
}
